import React from 'react';
import DriverApplicationStatus from '../components/driver/DriverApplicationStatus';

const DriverApplicationStatusPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <DriverApplicationStatus />
    </div>
  );
};

export default DriverApplicationStatusPage;
